// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__29YIY","a":"Loading_a__1TjZt"};